<script lang="js">
import TableDetailsExtends from './TableDetails.vue'

export default {
  name: 'LookupTableDetails',
  extends: TableDetailsExtends,

  data() {
    return {
      prevTabName: 'lookupTable',
      kind: 'lookup',
    }
  },
}
</script>
